import { createSlice } from "@reduxjs/toolkit";
import { companyInitState, companySliceName } from ".";
import { getCoursesAction } from "./actions/courseActions";
import { getCompanyAction } from "./actions/getCompanyAction";
import { getWeekdaysAction } from "./actions/getWeekdaysAction";
import { getGradesAction } from "./actions/gradeActions";
import { getSubjectsAction } from "./actions/subjectActions";
import { getTeachersAction } from "./actions/teacherActions";
import { getTimeframesAction } from "./actions/timeframeActions";
import { getAppUsersAction } from "./actions/appUserActions";
import { getEmailTemplatesAction } from "./actions/emailTemplateActions";

const companySlice = createSlice({
  name: `${companySliceName}`,
  initialState: companyInitState,
  reducers: {
    resetCompanyStateAction: () => {
      return companyInitState;
    },
    selectSubsidiaryAction: (state, action) => {
      state.subsidiarySelected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCompanyAction.fulfilled, (state, action) => {
      state.uuid = action.payload.response?.uuid;
      state.name = action.payload.response?.name;
      state.phone = action.payload.response?.phone;
      state.hotline = action.payload.response?.hotline;
      state.address = action.payload.response?.address;
      state.email = action.payload.response?.email;
      state.password = action.payload.response?.password;
      state.website = action.payload.response?.website;
      state.subsidiaries = action.payload.response?.subsidiaries;
    });
    builder.addCase(getTimeframesAction.fulfilled, (state, action) => {
      state.timeframes = action.payload.response;
    });
    builder.addCase(getGradesAction.fulfilled, (state, action) => {
      state.grades = action.payload.response;
    });
    builder.addCase(getSubjectsAction.fulfilled, (state, action) => {
      state.subjects = action.payload.response;
    });
    builder.addCase(getTeachersAction.fulfilled, (state, action) => {
      state.teachers = action.payload.response;
    });
    builder.addCase(getCoursesAction.fulfilled, (state, action) => {
      state.courses = action.payload.response;
    });
    builder.addCase(getWeekdaysAction.fulfilled, (state, action) => {
      state.weekdays = action.payload.response;
    });
    builder.addCase(getAppUsersAction.fulfilled, (state, action) => {
      state.appUsers = action.payload.response;
    });
    builder.addCase(getEmailTemplatesAction.fulfilled, (state, action) => {
      state.emailTemplates = action.payload.response || [];
    });
  },
});

export const { selectSubsidiaryAction, resetCompanyStateAction } = companySlice.actions;
const companyReducer = companySlice.reducer;
export default companyReducer;
